import { lt } from '@mews/framework';
import { PaymentRequestReasonText } from '../../../tables/PaymentRequest/PaymentRequestReason';
import { useGetPaymentRequestDetailSuspense } from '../hooks';
import { PaymentLinkDetailItem } from '../../PaymentLink/PaymentLinkDetails/PaymentLinkDetailItem';

export const PaymentRequestReasonInfoRow = ({ paymentRequestId }: { paymentRequestId: string }) => {
    const { data: paymentRequest } = useGetPaymentRequestDetailSuspense({ paymentRequestId });

    if (!paymentRequest) {
        return null;
    }

    return (
        <PaymentLinkDetailItem
            description={lt('Reason')}
            value={<PaymentRequestReasonText paymentRequestReason={paymentRequest.reason} />}
        />
    );
};
